var _rect, _path, _polyline, _path2, _path3, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreestandingSink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Freestanding Sink") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4.21-4.15",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "15.32 11.53 12.6 2.6 2.97 2.6 0.66 11.53",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.75,11.06c0,.2-.28.87-.09,1.31a1.48,1.48,0,0,0,.71.75c1.52.33,1.37.3,1.52.26H13c.13,0,0,.07,1.52-.17a1.54,1.54,0,0,0,.74-.73c.21-.41,0-1.1,0-1.3",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64,8a3.52,3.52,0,0,1,3.15-3.5,3.48,3.48,0,0,1,3.5,2.92A3.93,3.93,0,0,1,8,11.56,4,4,0,0,1,4.64,8Z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.96,
    cy: 6.77,
    rx: 0.33,
    ry: 0.59,
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreestandingSink);
export default __webpack_public_path__ + "static/media/FreestandingSink.09ad64ec830a964c88c14c1a77b66a92.svg";
export { ForwardRef as ReactComponent };